import React, { FC, useEffect, useState } from 'react';
import useSnackbarHelper from '../../../../hooks/snackbar.hook';
import TrainingLogPageHeader from '../../components/training-log-page-header/training-log-page-header.component';
import { MetricMode } from '../../training-log.helpers';
import { useTrainingLogContext } from '../../training-log.context';
import RawDataTable from './raw-data-table.component';
import './raw-data.page.css';

const RawDataPage: FC = () => {
  const { stats, loading, error, attendanceTeams, attendanceLoading, hideAttendance, onNavigateToTrainingLog } =
    useTrainingLogContext();
  const { showSnackbar } = useSnackbarHelper();
  const [mode, setMode] = useState<MetricMode>('duration');

  useEffect(() => {
    if (error) {
      showSnackbar('There was an error loading your training stats. Please try again.', 'error');
    }
  }, [error, showSnackbar]);

  const isLoading = hideAttendance ? loading : loading || attendanceLoading;

  return (
    <div className="raw-data-page">
      <TrainingLogPageHeader
        title="Raw Data"
        subtitle="Annual training grid — all weeks at a glance"
        showSeasonDateRange
        className="training-log-page-header--constrained"
      />

      {isLoading ? (
        <div className="raw-table-wrap">
          <div className="raw-data-skeleton" />
        </div>
      ) : (
        <RawDataTable
          stats={stats}
          attendanceTeams={hideAttendance ? null : attendanceTeams}
          mode={mode}
          onModeChange={setMode}
          onNavigateWeek={onNavigateToTrainingLog}
        />
      )}
    </div>
  );
};

export default RawDataPage;
